import { render } from "./AllExtracts.vue?vue&type=template&id=47a353d5&scoped=true"
import script from "./AllExtracts.vue?vue&type=script&lang=js"
export * from "./AllExtracts.vue?vue&type=script&lang=js"

import "./AllExtracts.vue?vue&type=style&index=0&id=47a353d5&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a353d5"]])

export default __exports__